import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import DatePicker from 'react-datepicker/es';
import SubmitButton from '../_shared/SubmitButton';
import axios from 'axios';
import { snakeCaseToTitle } from '../../utils/Helpers';
import FormError from '../_shared/forms/FormError';

export default class JobsReport extends Component {
    constructor(props) {
        super(props);

        this.state = {
            date_from: '',
            date_to: '',
            loading: false,
            errors: {},
            noJobsFound: false,
            providerSearch: this.props.providerSearch,
        };
    }

    handleDateChange = (date, property) => {
        this.setState({
            [property]: date,
        });
    };

    onSubmit = (e) => {
        e.preventDefault();

        this.setState({
            noJobsFound: false,
        });

        if (this.validateForm()) {
            this.setState({
                loading: true,
            });

            const date_from = moment(this.state.date_from).format('YYYY-MM-DD');
            const date_to = moment(this.state.date_to).format('YYYY-MM-DD');

            const file_name = 'jobs-' + date_from + '-to-' + date_to + '.xlsx';
            axios({
                url: this.props.url,
                method: 'GET',
                responseType: 'blob',
                params: {
                    date_from: date_from,
                    date_to: date_to,
                    provider_search: this.state.providerSearch,
                },
            })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', file_name); //or any other extension
                    document.body.appendChild(link);
                    link.click();

                    this.setState({
                        loading: false,
                    });
                })
                .catch((error) => {
                    this.setState({
                        noJobsFound: true,
                        loading: false,
                    });
                });
        }
    };

    validateForm = () => {
        let errors = {};
        const fields = ['date_from', 'date_to'];

        fields.map((field) => {
            if (!this.state[field]) {
                errors[field] = `${snakeCaseToTitle(field).replace('id', '')} field is required`;
            }
        });

        this.setState({ errors: errors });

        if (Object.keys(errors).length > 0) {
            toastr.error('Please fill in all required fields');
        }

        return Object.keys(errors).length === 0;
    };

    render() {
        return (
            <form onSubmit={this.onSubmit}>
                <div className="row">
                    <div className="col-md-12">
                        <h4 className="text-center">Filter jobs</h4>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4 form-group">
                        <DatePicker
                            className="form-control"
                            placeholderText="Date from..."
                            onChange={(date) => this.handleDateChange(date, 'date_from')}
                            selected={this.state.date_from}
                            dateFormat="dd/MM/yyyy"
                            isClearable
                        />
                        <FormError error={this.state.errors.date_from} />
                    </div>
                    <div className="col-md-4 form-group">
                        <DatePicker
                            className="form-control"
                            placeholderText="Date to..."
                            onChange={(date) => this.handleDateChange(date, 'date_to')}
                            selected={this.state.date_to}
                            dateFormat="dd/MM/yyyy"
                            isClearable
                        />
                        <FormError error={this.state.errors.date_to} />
                    </div>
                    <div className="col-md-4 form-group">
                        <SubmitButton buttonText={'Download'} loading={this.state.loading} style={{ width: 200 }} />
                    </div>
                </div>
                {this.state.noJobsFound ? (
                    <div className="row">
                        <div className="col-md-12">
                            <p className="text-danger text-center">No jobs found</p>
                        </div>
                    </div>
                ) : (
                    ''
                )}
            </form>
        );
    }
}

if (document.getElementById('jobs-report')) {
    let element = document.getElementById('jobs-report');
    ReactDOM.render(<JobsReport url={element.dataset.url} providerSearch={element.dataset.provider_search} />, element);
}
